import { render, staticRenderFns } from "./TreeView.vue?vue&type=template&id=387e68ba&scoped=true&"
import script from "./TreeView.vue?vue&type=script&lang=js&"
export * from "./TreeView.vue?vue&type=script&lang=js&"
import style0 from "./TreeView.vue?vue&type=style&index=0&id=387e68ba&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387e68ba",
  null
  
)

export default component.exports